import { createFileRoute } from "@tanstack/react-router"
import { procedureTypeSettingsGeneralViewStaticData } from "src/views/ProcedureTypeSettingsGeneralView/constants"
import { ProcedureTypeSettingsGeneralView } from "src/views/ProcedureTypeSettingsGeneralView/ProcedureTypeSettingsGeneralView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/general",
)({
	component: ProcedureTypeSettingsGeneralView,
	staticData: procedureTypeSettingsGeneralViewStaticData,
})
